export const datatable = {
  ICON_EYE: 'fa fa-eye',
  ICON_EDIT: 'fa fa-edit',
  ICON_TRASH: 'fa fa-trash',

  MDI_MAGNIFY: 'mdi-magnify',
};

export const list = {
  ICON_PLUS: 'fas fa-plus',
  ICON_TRASH: 'fas fa-trash',
};

export const create = {
  ICON_PLUS: 'fa fa-plus',
  ICON_TRASH: 'fa fa-trash',
};

export const edit = {
  ICON_PLUS: 'fas fa-plus',
  ICON_TRASH: 'fas fa-trash',
};

export const show = {};
